<div class="offset-lg-9 offset-md-8 col-md-3">
  <div *ngIf="canAddTrafficChannels" style="width: 200px">
    <button
      psUiButton
      class="btn-left-circle font-size add-trafic-channel"
      [disabled]="survey.status !== surveyStatus.Live"
    >
      Add Traffic Channel
    </button>
    <button
      psUiButton
      [psUiDropdownToggleFor]="menu"
      id="open-traffic-channel-options"
      class="btn-right-circle font-size add-trafic-channel"
      [disabled]="survey.status !== surveyStatus.Live"
    >
      <i class="fa fa-angle-down"></i>
    </button>
  </div>
  <ps-ui-dropdown #menu="psUiDropdown" class="dropdown_items">
    <ps-ui-dropdown-item
      id="create-rep-tc"
      (click)="createTCSurvey('REPLICA', 'surveyDetailsPage')"
      >Replica</ps-ui-dropdown-item
    >
    <ps-ui-dropdown-item
      id="create-spa-tc"
      (click)="createTCSurvey('SPECIFIC AUDIENCE', 'surveyDetailsPage')"
      >Specific Audience</ps-ui-dropdown-item
    >
    <ps-ui-dropdown-item
      id="create-tl-tc"
      (click)="createTCSurvey('TARGETED LIST', 'surveyDetailsPage')"
      >Targeted List</ps-ui-dropdown-item
    >
  </ps-ui-dropdown>
</div>
<hr *ngIf="canAddTrafficChannels" />
<ng-container *ngIf="surveys$ | async as surveys">
  <ps-ui-surveys-table
    [tableHeaders]="tcSurveyTableHeaders"
    [surveys]="surveys"
    [isTCTab]="true"
    [isSingleCountrySurvey]="true"
    [scrollable]="false"
    [isCpiEditModeDisabled]="isCpiEditModeDisabled"
    [isPdsIgnoreOverride]="survey.pds_ignore_override"
  ></ps-ui-surveys-table>
</ng-container>
